import { medicanAPIConfig } from "./config";

export const updateIntegratedData = async (subjectId: string | number) => {
  const url = `/integrate/${subjectId}`;
  const res = await medicanAPIConfig.post(url, {}, { params: {apikey: sessionStorage.token} });
  return res;
};
